export default __webpack_public_path__ + "static/media/Mark-3-Blueprints-01.40176acf.jpg";